module.exports = __webpack_public_path__ + "static/media/people.3877937d.png";